(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cro-mobile-gallery-cues"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cro-mobile-gallery-cues')) {
    class CroMobileGalleryCues extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('.product__main-photos')?.querySelector('[data-product-photos]');
        this.counter = this.querySelector('[data-cro-gallery-counter]');
        this.hint = this.querySelector('[data-cro-gallery-hint]');
        if (!this.gallery || !this.counter || !this.hint) return;

        this.hasInteracted = false;
        this.previousIndex = null;

        this.getSlides = () => {
          const activeSlides = this.gallery.querySelectorAll('.flickity-slider > .product-main-slide');
          return activeSlides.length ? Array.from(activeSlides) : Array.from(this.gallery.querySelectorAll(':scope > .product-main-slide'));
        };

        this.updateCounter = () => {
          const slides = this.getSlides();
          const selectedIndex = slides.findIndex((slide) => slide.classList.contains('is-selected'));
          if (!slides.length || selectedIndex < 0) return;

          this.counter.textContent = `${selectedIndex + 1} / ${slides.length}`;

          if (this.previousIndex === null) {
            this.previousIndex = selectedIndex;
            return;
          }

          if (this.hasInteracted && selectedIndex !== this.previousIndex) {
            this.hint.hidden = true;
          }

          this.previousIndex = selectedIndex;
        };

        this.markInteraction = () => {
          this.hasInteracted = true;
        };

        this.gallery.addEventListener('pointerdown', this.markInteraction, { passive: true });
        this.gallery.addEventListener('touchstart', this.markInteraction, { passive: true });

        this.observer = new MutationObserver(this.updateCounter);
        this.observer.observe(this.gallery, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true,
          subtree: true
        });

        requestAnimationFrame(this.updateCounter);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.gallery?.removeEventListener('pointerdown', this.markInteraction);
        this.gallery?.removeEventListener('touchstart', this.markInteraction);
      }
    }

    customElements.define('cro-mobile-gallery-cues', CroMobileGalleryCues);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cro-product-reassurance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cro-product-reassurance')) {
    class CroProductReassurance extends HTMLElement {
      connectedCallback() {
        this.productBlocks = this.closest('[data-product-blocks]');
        if (!this.productBlocks) return;

        this.positionSizeGuide = () => {
          const sizeFieldset = Array.from(this.productBlocks.querySelectorAll('.variant-input-wrap'))
            .find((fieldset) => fieldset.dataset.handle?.includes('size'));
          if (!sizeFieldset) return true;

          const variantWrapper = sizeFieldset.closest('.variant-wrapper');
          const variantLabel = variantWrapper?.querySelector('.variant__label');
          const appButton = this.productBlocks.querySelector('[data-app="eastsideco_sizeGuides"] button');
          
          if (!variantWrapper || !variantLabel || !appButton) return false;
          if (variantWrapper.querySelector('.cro-size-guide-link')) return true;
          const appBlock = appButton.closest('.shopify-app-block');

          const sizeGuideButton = document.createElement('button');
          sizeGuideButton.type = 'button';
          sizeGuideButton.className = 'cro-size-guide-link';
          sizeGuideButton.textContent = this.dataset.sizeGuideLabel;
          sizeGuideButton.addEventListener('click', () => appButton.click());

          const labelRow = document.createElement('div');
          labelRow.className = 'cro-size-guide-row';
          variantWrapper.insertBefore(labelRow, variantLabel);
          labelRow.append(variantLabel, sizeGuideButton);

          appBlock?.classList.add('cro-size-guide-source--moved');
          return true;
        };

        if (this.positionSizeGuide()) return;

        this.sizeGuideObserver = new MutationObserver(() => {
          if (this.positionSizeGuide()) this.sizeGuideObserver.disconnect();
        });
        this.sizeGuideObserver.observe(document.body, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.sizeGuideObserver?.disconnect();
      }
    }

    customElements.define('cro-product-reassurance', CroProductReassurance);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cro-sticky-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cro-sticky-cart')) {
    class CroStickyCart extends HTMLElement {
      connectedCallback() {
        this.productSection = this.closest('.product-section');
        this.primaryButton = this.productSection?.querySelector('[data-add-to-cart]');
        this.stickyButton = this.querySelector('[data-cro-sticky-submit]');
        this.stickyText = this.querySelector('[data-cro-sticky-text]');
        this.stickyPrice = this.querySelector('[data-cro-sticky-price]');

        if (!this.productSection || !this.primaryButton || !this.stickyButton) return;

        this.syncButton = () => {
          const primaryText = this.primaryButton.querySelector('[data-add-to-cart-text]');
          this.stickyButton.disabled = this.primaryButton.disabled;
          if (primaryText && this.stickyText) this.stickyText.textContent = primaryText.textContent.trim();
        };

        this.onVariantChange = () => {
          window.requestAnimationFrame(() => {
            const productPrice = this.productSection.querySelector('[data-product-price]');
            if (productPrice && this.stickyPrice) this.stickyPrice.textContent = productPrice.textContent.trim();
            this.syncButton();
          });
        };

        this.buttonObserver = new MutationObserver(this.syncButton);
        this.buttonObserver.observe(this.primaryButton, {
          attributes: true,
          childList: true,
          subtree: true
        });

        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          const hasPassedPrimaryButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', hasPassedPrimaryButton);
          this.setAttribute('aria-hidden', hasPassedPrimaryButton ? 'false' : 'true');
        }, { threshold: 0 });

        this.visibilityObserver.observe(this.primaryButton);
        this.productSection.addEventListener('variantChange', this.onVariantChange);
        this.syncButton();
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.productSection?.removeEventListener('variantChange', this.onVariantChange);
      }
    }

    customElements.define('cro-sticky-cart', CroStickyCart);

    const updateCroStickyCartVisibility = () => {
      document.querySelectorAll('cro-sticky-cart').forEach((stickyCart) => {
        const primaryButton = stickyCart.closest('.product-section')?.querySelector('[data-add-to-cart]');
        if (!primaryButton) return;

        const hasPassedPrimaryButton = primaryButton.getBoundingClientRect().bottom < 0;
        stickyCart.classList.toggle('is-visible', hasPassedPrimaryButton);
        stickyCart.setAttribute('aria-hidden', hasPassedPrimaryButton ? 'false' : 'true');
      });
    };

    window.addEventListener('scroll', updateCroStickyCartVisibility, { passive: true });
    window.requestAnimationFrame(updateCroStickyCartVisibility);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cro-variant-availability"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cro-variant-availability')) {
    class CroVariantAvailability extends HTMLElement {
      connectedCallback() {
        this.productSection = this.closest('.product-section');
        if (!this.productSection) return;

        this.helpLink = this.querySelector('[data-cro-size-help]');
        this.sizeFieldset = Array.from(this.productSection.querySelectorAll('.variant-input-wrap'))
          .find((fieldset) => fieldset.dataset.handle?.includes('size'));

        this.updateHelpLink = () => {
          const appLink = this.productSection.querySelector('.wa__button[href]');
          const selectedSize = this.sizeFieldset?.querySelector('[data-variant-input]:checked')?.value;
          if (!appLink || !selectedSize || !this.helpLink) return false;

          const helpUrl = new URL(appLink.getAttribute('href'), window.location.origin);
          const message = this.dataset.sizeHelpMessage.replace('[size]', selectedSize);
          helpUrl.searchParams.set('text', `${message}\n${window.location.href}`);

          this.helpLink.href = helpUrl.toString();
          this.helpLink.target = appLink.target || '_blank';
          this.helpLink.rel = 'noopener';
          this.helpLink.hidden = false;

          const sourceBlock = appLink.closest('.shopify-app-block') || appLink;
          sourceBlock.classList.add('cro-size-help-source--hidden');
          return true;
        };

        this.onVariantChange = (event) => {
          this.hidden = !event.detail.variant?.available;
          this.updateHelpLink();
        };

        this.productSection.addEventListener('variantChange', this.onVariantChange);

        if (!this.updateHelpLink()) {
          this.appObserver = new MutationObserver(() => {
            if (this.updateHelpLink()) this.appObserver.disconnect();
          });
          this.appObserver.observe(this.productSection, { childList: true, subtree: true });
        }
      }

      disconnectedCallback() {
        this.appObserver?.disconnect();
        this.productSection?.removeEventListener('variantChange', this.onVariantChange);
      }
    }

    customElements.define('cro-variant-availability', CroVariantAvailability);
  }
  } catch(e) { console.error(e); }
})();

})();
